jQuery(document).ready(function($){
  console.log('Hello Roberto');
});
